import { FC, useMemo, useState } from "react"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import TextInput from "@/components/shared/TextInput"
import { ColorVariant } from "@/types/index"
import "./index.scss"

interface WearableNewInmateAssignmentProps {
   isLoading: boolean
   wearableId: string
   onBack: () => void
   onSave: (inmateName: string) => void
}

const WearableNewInmateAssignment: FC<WearableNewInmateAssignmentProps> = ({
   isLoading,
   wearableId,
   onBack,
   onSave,
}) => {
   const [inmateName, setInmateName] = useState("")
   const isSaveDisabled = useMemo(() => {
      return inmateName.trim() === "" || isLoading
   }, [inmateName, isLoading])
   const title = (
      <>
         Please enter the new inmate name to connect it to ReassureBand&nbsp;
         {wearableId && (
            <span className="wearable-new-inmate-assignment__wearable-id">
               {wearableId}
            </span>
         )}
      </>
   )

   return (
      <div className="wearable-new-inmate-assignment__container">
         <div className="wearable-new-inmate-assignment__title">{title}</div>
         <div className="wearable-new-inmate-assignment__input-field">
            <TextInput
               name="inmate-name"
               placeholder="New inmate name"
               onChange={(e) => {
                  setInmateName(e.target.value)
               }}
               value={inmateName}
            />
         </div>

         <div className="wearable-new-inmate-assignment__actions">
            <Button
               color={ColorVariant.HONOLULU_BLUE}
               className="wearable-new-inmate-assignment__button"
               iconPosition={ButtonIconPosition.LEFT}
               onClick={onBack}
               iconName="arrowLeft"
            >
               Back
            </Button>
            <Button
               color={ColorVariant.HONOLULU_BLUE}
               className="wearable-new-inmate-assignment__button-save"
               iconPosition={ButtonIconPosition.LEFT}
               onClick={() => onSave(inmateName)}
               iconName="save"
               disabled={isSaveDisabled}
            >
               Save and connect
            </Button>
         </div>
      </div>
   )
}

export default WearableNewInmateAssignment
